module.exports = __webpack_public_path__ + "assets/img/CUA-Social-Static-Ad.e52d6f62.png";